module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    attrs: {
      "id": "#app"
    }
  }, [_c('toolbar'), _vm._v(" "), _c('main', {
    staticStyle: {
      "background-color": "white",
      "min-height": "100vh"
    }
  }, [_c('v-container', {
    attrs: {
      "id": "main-container",
      "fluid": ""
    }
  }, [_c('router-view'), _vm._v(" "), _c('back-top')], 1)], 1), _vm._v(" "), _c('app-footer')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a509891"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 432
// module chunks = 0